import { render } from "./contactViewNew.vue?vue&type=template&id=b125ef1e&scoped=true"
import script from "./contactViewNew.vue?vue&type=script&lang=js"
export * from "./contactViewNew.vue?vue&type=script&lang=js"

import "./contactViewNew.vue?vue&type=style&index=0&id=b125ef1e&scoped=true&lang=css"

import exportComponent from "C:\\Users\\lenovo\\Desktop\\canadianlic\\client\\app\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b125ef1e"]])

export default __exports__